import React from 'react'

interface Props {
  text: string
}
export const Answer: React.FC<Props> = ({ text }) => {
  return <p className="mt-4 font-body text-sm text-ar-dark-gray">{text}</p>
}
